import request from '@/api/request'

export interface AdminRow {
  id: number
  username: string
  gid: number
  addtime: number
  lastlogin: number
  status: number
}

export function fetchAdmins() {
  return request.get<AdminRow[]>('/api/admin/admins')
}

export function createAdmin(body: Record<string, unknown>) {
  return request.post<AdminRow>('/api/admin/admins', body)
}

export function patchAdmin(id: number, body: Record<string, unknown>) {
  return request.patch<AdminRow>(`/api/admin/admins/${id}`, body)
}

export function deleteAdmin(id: number) {
  return request.delete<{ status: number; msg: string }>(`/api/admin/admins/${id}`)
}
